/** Cancellation allowed through end of 31 July 2026 (UTC). */
export const CANCELLATION_DEADLINE = new Date("2026-07-31T23:59:59.999Z");

export const CANCELLATION_ADMIN_FEE_USD = 100;

export const CANCELLATION_POLICY_SUMMARY =
  "Cancellation is possible until 31 July 2026 with an administrative cost of $100. After this date, no refunds are available. It can take approximately 10 days to appear on your account.";

export function isCancellationAllowed(now = new Date()): boolean {
  return now <= CANCELLATION_DEADLINE;
}

export function formatNetRefundUsd(
  orderTotalUsd: number,
  waiveAdminFee = false,
): number {
  if (waiveAdminFee) return orderTotalUsd;
  return Math.max(0, orderTotalUsd - CANCELLATION_ADMIN_FEE_USD);
}
